import UIPane from './UIPane.vue'
import UIPanelCard from './UIPanelCard.vue'
import UIPanelSection from './UIPanelSection.vue'

export default UIPane
export { UIPanelCard, UIPanelSection }
